var map = {
	"./champions_league.embedded.svg": 1233,
	"./conmebol_icon.embedded.svg": 1234,
	"./csgo_icon.embedded.svg": 1235,
	"./dota2_icon.embedded.svg": 1236,
	"./dreamhack_icon.embedded.svg": 1237,
	"./esl_icon.embedded.svg": 1238,
	"./fifa.embedded.svg": 1239,
	"./fnatic_icon.embedded.svg": 1240,
	"./fortnite.embedded.svg": 1241,
	"./i_league_icon.embedded.svg": 1242,
	"./logo-12up.embedded.svg": 529,
	"./logo-90min.embedded.svg": 530,
	"./logo-dbltap.embedded.svg": 531,
	"./logo-ei.embedded.svg": 532,
	"./logo-floor8.embedded.svg": 533,
	"./logo-ftb90.embedded.svg": 534,
	"./logo-german_site.embedded.svg": 535,
	"./logo-ht_media.embedded.svg": 536,
	"./logo-pluralist.embedded.svg": 537,
	"./lol_icon.embedded.svg": 1243,
	"./mdl_icon.embedded.svg": 1244,
	"./melee_icon.embedded.svg": 1245,
	"./mlb_icon.embedded.svg": 1246,
	"./mls_icon.embedded.svg": 1247,
	"./nba_icon.embedded.svg": 1248,
	"./ncaa-basketball_icon.embedded.svg": 1249,
	"./ncaa-football_icon.embedded.svg": 1250,
	"./nfl_icon.embedded.svg": 1251,
	"./overwatch_icon.embedded.svg": 1252,
	"./powered-by-ei.embedded.svg": 538,
	"./powered-by-german_site.embedded.svg": 539,
	"./powered-by-ht_media.embedded.svg": 540,
	"./pubg.embedded.svg": 1253,
	"./smash4_icon.embedded.svg": 1254,
	"./streetfighter_icon.embedded.svg": 1255,
	"./world-cup.embedded.svg": 1256,
	"./yousport_icon.embedded.svg": 1257
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1268;


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/images ^\.\/.*\.embedded\.svg$
// module id = 1268
// module chunks = 20